import { render, staticRenderFns, recyclableRender, components } from "./upgrade-popup.vue?vue&type=template&id=3858945d&"
var renderjs
import script from "./upgrade-popup.vue?vue&type=script&lang=js&"
export * from "./upgrade-popup.vue?vue&type=script&lang=js&"
import style0 from "./upgrade-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-upgrade-center-app/pages/upgrade-popup.vue"
export default component.exports